import React from "react";
import clsx from "clsx";
import ArrowRightIcon from "icons/ArrowRightIcon.js";
import ItemTime from "../ItemTime.js";
import ActItemSubscript from "../../listTypes/act/ActItemSubscript";

export default function Task({
  details,
  currentTimeInMinutes,
  isToday,
  isDue,
  listType,
  dateHelper,
}) {
  const className = "item Task " + details.task_type;
  const hasPrefix = listType === "Plan" || (isToday && details.time);
  const itemPrefix = <div className="item-prefix">{prefixContents()}</div>;

  function prefixContents() {
    return (
      <>
        {isDue && listType !== "Act" && (
          <span className="task-due-label">Due</span>
        )}

        {details.time && !isDue && (
          <ItemTime
            prettyTime={details.time}
            currentTimeInMinutes={currentTimeInMinutes}
            itemTimeInMinutes={details.time_in_minutes}
            isToday={isToday}
            itemType="task"
          />
        )}

        {!isToday && !isDue && details.active_date === details.day && (
          <ArrowRightIcon className="date-specific-task-icon" />
        )}
      </>
    );
  }

  function isBold() {
    return details.task_type === "critical";
  }

  function contents() {
    return (
      <div className={className} data-testid="plan-task">
        {hasPrefix && itemPrefix}
        <div className="item-stacked-text">
          <div
            className={clsx({
              "task-name": true,
              "bold-item-txtstyl": isBold(),
            })}
          >
            {details.name}
          </div>
          {listType === "Act" && (
            <ActItemSubscript details={details} dateHelper={dateHelper} />
          )}
        </div>
      </div>
    );
  }
  return contents();
}
